import config from '@app/config';
import ServerCookies, { ICookie } from 'cookie-universal';
import { ServerResponse } from 'http';
import { nanoid } from 'nanoid';
import type { CookieSetOptions } from 'universal-cookie';
import Cookies from 'universal-cookie';

class ServiceCookies {
  KEY = 'PHPSESSID';
  UUID = 'mindboxDeviceUUID';
  DEVICE_ID = 'X-Device-UUID';
  JWT_HEADER = 'token';
  RF_HEADER = 'refresh-token';
  JWT_ACCESS = 'access_token_koleso';
  JWT_REFRESH = 'refresh_token_koleso';
  INFINITY_COOKIE = 'infinity_cookie';
  SESSION_NEW_USER = 'new_user_session';
  YELLOW_SLOTS = 'skip_reserve_slots';
  YELLOW_SLOTS_BANNER = 'blockYellowSlotsV1';
  ROUTE_LK = 'route_LK';
  YELLOW_SLOTS_TIME = 3600 * 24 * 3;
  INFINITY_COOKIE_TIME = 3600 * 24 * 31_536_000_000 * 100; // на сто лет
  TIME_DAY = 24 * 1000 * 60 * 60;
  cookies: Cookies = new Cookies();
  serverCookies: ICookie;
  res: ServerResponse;
  newServerCookies: string[];

  start(context?): string {
    if (context && context.req) {
      this.cookies = new Cookies(context.req.headers.cookie);
      this.serverCookies = ServerCookies(context.req, context.res);
      this.res = context.res;
    }
    this.newServerCookies = [];
    this.generateFlagNewUser(); // Cookies for tracking a new user
    return this.cookies.get(this.KEY) ? this.cookies.get(this.KEY) : this.generateSessionId();
  }

  generateSessionId(): string {
    const SessionId = nanoid().replaceAll('_', '');
    this.cookies.set(this.KEY, SessionId, {
      path: '/',
    });
    return SessionId;
  }

  setSessionId(value: string): void {
    this.cookies.set(this.KEY, value, {
      path: '/',
    });
  }

  get sessionId(): string {
    return this.cookies.get(this.KEY) ? this.cookies.get(this.KEY) : this.generateSessionId();
  }

  get jwtAccess(): string {
    return this.cookies.get(this.JWT_ACCESS) || '';
  }

  get jwtRefresh(): string {
    return this.cookies.get(this.JWT_REFRESH) || '';
  }

  get mindboxDeviceUUID(): string {
    return this.cookies.get(this.UUID) ? this.cookies.get(this.UUID) : '';
  }

  getYellowSlot(): boolean {
    return !!this.cookies.get(this.YELLOW_SLOTS);
  }

  setYellowSlot(): void {
    const timeCookies = new Date(new Date().getTime() + this.YELLOW_SLOTS_TIME);
    this.cookies.set(this.YELLOW_SLOTS, '1', {
      path: '/',
      domain: config.baseDomain,
      expires: timeCookies,
    });
  }

  generateFlagNewUser() {
    if (!this.cookies.get(this.INFINITY_COOKIE)) {
      this.cookies.set(this.SESSION_NEW_USER, '1', {
        path: '/',
        domain: config.baseDomain,
      });
    }
    this.cookies.set(this.INFINITY_COOKIE, '1', {
      path: '/',
      domain: config.baseDomain,
      maxAge: this.INFINITY_COOKIE_TIME,
    });
  }

  get(key: string): string {
    return this.cookies.get(key);
  }

  set(key: string, value: string, options?: CookieSetOptions): void {
    if (typeof document === 'undefined') {
      this.serverCookies.set(key, value, options);
    } else {
      this.cookies.set(key, value, options);
    }
  }

  remove(key: string, options?: CookieSetOptions): void {
    if (typeof document === 'undefined') {
      this.serverCookies.remove(key, options);
    } else {
      this.cookies.remove(key, options);
    }
  }

  getLifeTimeCookies(days: number): Date {
    return new Date(new Date().getTime() + days * this.TIME_DAY);
  }

  updateJWTTokens(assesToken: string, refreshToken: string, saveMe?: boolean): void {
    const timeCookies = new Date(new Date().getTime() + 30 * this.TIME_DAY);
    const options: CookieSetOptions = {
      path: '/',
      expires: timeCookies,
      domain: config.baseDomain,
    };

    this.set(this.JWT_ACCESS, assesToken, options);
    this.set(this.JWT_REFRESH, refreshToken, options);
  }

  removeJWTTokens(): void {
    const options: CookieSetOptions = {
      path: '/',
      domain: config.baseDomain,
      httpOnly: false,
    };
    this.remove(this.JWT_ACCESS, options);
    this.remove(this.JWT_REFRESH, options);
    this.remove(this.ROUTE_LK, options);
  }
}

const serviceCookiesInstance = new ServiceCookies();

export default serviceCookiesInstance;
